<template>
    <div class="invoice-summary-view">
        <HeaderComponent title="Resumo das Faturas" />

        <div class="invoices">
            <template v-if="hasAnyInvoiceData()">
                <div v-for="(inv, ikey) in invoiceData" :key="ikey" ref="lastInvoice">
                    <div class="invoice-item" @click="selectInvoice(inv)">
                        <div class="invoice-item-bar">
                            <div class="invoice-item-bar-value" :style="{ height: (inv.amount / maxVal) * 100 + '%' }" value="inv.amount" :class="{ 'selected': inv === currentInvoice }"></div>
                        </div>
                        <div class="invoice-item-title">
                            <h1 v-text="inv.month"></h1>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="empty-view">
                    <i class="fa fa-usd fa-3x"></i>
                    <span>Ainda não há débitos para este período</span>
                </div>
            </template>
        </div>

        <div class="current-invoice" v-if="currentInvoice">
            <div class="status">
                <h1 v-text="getPaidOrNotPaidText()" :class="{ 'paid': currentInvoice.status }"></h1>
            </div>
            <div class="current-invoice-title">
                <h1>Fatura de {{ currentInvoice.month }}/{{ currentInvoice.year }}</h1>
                <h2 v-text="getDueDateText()"></h2>
            </div>
            <div class="current-invoice-value">
                <h1 v-text="formatValue(currentInvoice.amount)"></h1>
            </div>
        </div>

        <div v-if="paymentButtonsVisible" class="menulist-container">
            <div class="menulist-item" v-for="(cItem, cKey) in actions" :key="cKey" @click="handleAction(cItem)">
                <i :class="`fa ${cItem['icon']}`"></i>
                <h3 v-html="cItem['display']"></h3>
            </div>
        </div>

        <div class="overlay" v-if="showInvoiceDetails" @click="showInvoiceDetails = false"></div>
        <div class="invoice-details" v-if="showInvoiceDetails">
            <h1>Pagamentos em pendência</h1>
            <div class="indebt-invoices" v-for="(invoice, key) in getInvoicesInDebt()" :key="key">
                <div class="indebt-invoices-item" @click="sendDataToClipBoard(invoice.DSLINHADIGI)">
                    <div class="inv-detail">
                        <span v-text="invoice.DSLINHADIGI"></span>
                        <span v-text="formatValue(invoice.VRFINALBREC)"></span>
                    </div>
                    <i class="fa-regular fa-clipboard"></i>
                </div>
            </div>
        </div>

        <ScreenLoader :isLoading="invoiceIsLoading"></ScreenLoader>
    </div>
</template>

<script>
import HeaderComponent from '../../components/header/HeaderComponent.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapGetters, mapActions } from 'vuex'
import { getInvoices } from '@/components/controllers/InvoiceController.js'
import { showSuccessNotification } from '@/libs/Util.js'
import moment from 'moment'
import { log } from '@/libs/Logger'

export default {
    name: 'InvoiceSummaryView',
    components: {
        HeaderComponent,
        ScreenLoader
    },
    data () {
        return {
            showInvoiceDetails: false,
            actions: [
                // {
                //     icon: 'fa-regular fa-envelope fa-lg',
                //     display: 'Enviar por email',
                //     action: 'sendEmail'
                // },
                {
                    icon: 'fas fa-barcode fa-lg',
                    display: 'Gerar código de barras',
                    action: 'generateBarcode'
                },
                {
                    icon: 'fas fas fa-credit-card',
                    display: 'Pagar com Cartão',
                    action: 'creditCardPayment'
                },
                {
                    icon: 'fa-solid fa-qrcode fa-lg',
                    display: 'Pagar com Pix',
                    action: 'pixPayment'
                }
            ],
            maxVal: 0,
            currentInvoice: null
        }
    },
    computed: {
        ...mapGetters(['invoiceData', 'invoiceIsLoading', 'getCurrDependent', 'paymentButtonsVisible'])
    },
    methods: {
        ...mapActions(['startInvoiceLoading', 'stopInvoiceLoading', 'setIsInvoiceMode', 'setInvoiceTotalValue',
            'setRechargeMode', 'setIdBoletos', 'setPaymentButtonsVisible']),
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        hasAnyInvoiceData () {
            return this.invoiceData?.length > 0
        },
        getPaidOrNotPaidText () {
            if (this.currentInvoice.status === 1) {
                return 'Fatura paga'
            } else if (this.currentInvoiceHasPayableDebits()) {
                return 'Fatura em aberto'
            } else {
                return 'Fatura em processamento'
            }
        },
        getDueDateText () {
            const today = moment()
            const dueDate = moment(this.currentInvoice.invoiceDetails[0].DTVENBOLREC)
            return `${today <= dueDate ? 'Vence em' : 'Venceu em'} ${this.currentInvoice.maturationDate}`
        },
        selectInvoice (inv) {
            this.currentInvoice = inv
            this.updatePaymentButtonsVisibility()
        },
        updatePaymentButtonsVisibility () {
            this.setPaymentButtonsVisible(this.currentInvoiceHasPayableDebits())
        },
        handleAction (cItem) {
            if (cItem.action) this[cItem.action]()
        },
        sendEmail () {
            log({ type: '', message: 'TODO: implementar "Enviar por email' })
        },
        generateBarcode () {
            if (this.currentInvoice?.invoiceDetails && this.getInvoicesInDebt().length > 0) {
                this.showInvoiceDetails = true
            }
        },
        sendDataToClipBoard (data) {
            showSuccessNotification({ text: 'Copiado para a área de transferencia.' })
            navigator.clipboard.writeText(data)
        },
        getInvoicesInDebt () {
            return this.currentInvoice.invoiceDetails.filter(i => i.IDSTATUS === 'E')
        },
        formatDate (date) {
            return moment(date).format('DD/MM/YYYY')
        },
        creditCardPayment () {
            if (this.currentInvoiceHasPayableDebits()) {
                this.setIsInvoiceMode(true)
                this.setInvoiceTotalValue(this.calculateInvoiceTotalValue())
                this.setIdBoletos(this.findIdBoletos())
                this.setRechargeMode('credit')
                this.$router.push('/cardRecharge/cardPayment')
            }
        },
        currentInvoiceHasPayableDebits () {
            // IDSTATUS === 'E' -> Expedido para o banco (pagável)
            // IDSTATUS === 'A' -> Em aberto, mas ainda não foi para o banco (não pagável)
            // IDSTATUS === 'B' -> Baixado, já foi pago
            return this.currentInvoice?.status === 0 &&
                this.currentInvoice.invoiceDetails.filter(element => element.IDSTATUS === 'E').length > 0
        },
        calculateInvoiceTotalValue () {
            let totalValue = 0

            if (this.currentInvoice?.invoiceDetails?.length > 0) {
                const payableItems = this.currentInvoice.invoiceDetails.filter(element => element.IDSTATUS === 'E')

                payableItems.forEach(element => {
                    totalValue = Math.round((parseFloat(totalValue) + parseFloat(element.VRFINALBREC)) * 100) / 100
                })
            }

            return totalValue
        },
        findIdBoletos () {
            const idBoletos = []
            const payableItems = this.currentInvoice.invoiceDetails.filter(element => element.IDSTATUS === 'E')
            payableItems.forEach(boleto => {
                idBoletos.push(boleto.NRLANBOLREC)
            })
            return idBoletos
        },
        pixPayment () {
            if (this.currentInvoiceHasPayableDebits()) {
                this.setIsInvoiceMode(true)
                this.setInvoiceTotalValue(this.calculateInvoiceTotalValue())
                this.setIdBoletos(this.findIdBoletos())
                this.setRechargeMode('pix')
                this.$router.push('/cardRecharge/pixPayment')
            }
        }
    },
    async mounted () {
        this.startInvoiceLoading()
        await getInvoices(this.getCurrDependent.CDCONSUMIDOR)

        this.maxVal = Math.max(...this.invoiceData.map(inv => inv.amount))
        this.currentInvoice = this.invoiceData[this.invoiceData.length - 1]

        // scroll starts at the last invoice
        const invoiceContainer = document.querySelector('.invoices')
        invoiceContainer.scrollLeft = invoiceContainer.scrollWidth

        this.updatePaymentButtonsVisibility()
    }
}

</script>

<style lang="less" scoped>
.invoice-summary-view {
    .invoices {
        background: rgba(0, 0, 0, 0.04);
        margin: 35px -15px 0 -15px;
        overflow: auto hidden;
        white-space: nowrap;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        align-items: flex-start;

        .invoice-item {
            position: relative;
            margin: 20px 20px;

            .invoice-item-bar {
                height: 20vh;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                margin-bottom: 10px;

                .invoice-item-bar-value {
                    background: #EDB098;
                    width: 5px;

                    &.selected {
                        background: var(--primaryColor);
                    }
                }
            }

            .invoice-item-title {
                h1 {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .empty-view {
            height: 25vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            span {
                white-space: break-spaces;
                text-align: center;
            }

            i {
                padding-bottom: 15px;
            }
        }
    }

    .current-invoice {
        display: flex;
        flex-direction: column;
        margin-top: 30px;

        .status {
            align-self: center;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 10px;
            border-radius: 5px;
            background: #df5d5d;

            &:has(h1.paid) {
                background: #70C169;
            }

            h1 {
                font-size: 16px;
                font-weight: 600;
                color: #fff;

                &.paid {
                    color: #fff;
                }
            }
        }

        .current-invoice-title {
            margin-top: 20px;

            h1 {
                font-size: 25px;
                font-weight: 600;
            }

            h2 {
                font-size: 18px;
                font-weight: 400;
                color: #8d8d8d;
                margin-top: 10px;
            }
        }

        .current-invoice-value {
            margin-top: 25px;

            h1 {
                font-size: 25px;
                font-weight: 600;
            }
        }
    }

    .menulist-container {
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 7.5px));
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        margin-top: 40px;

        .menulist-item {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            min-height: 90px;
            text-align: center;
            border-radius: 5px;
            border: 1px solid rgba(0, 0, 0, 0.18);
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
            transition: all linear .2s;
            padding: 10px;

            i {
                color: var(--primaryColor);
            }
            &:active{
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);
            }
        }
    }
    .overlay {
        position: fixed;
        top: 0; left: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.21);
        z-index: 2;
    }
    .invoice-details {
        position: absolute;
        z-index: 3;
        // height: 300px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        width: calc(100vw - 60px);
        border-radius: 15px;
        h1 {
            text-align: center;
            padding: 15px 0;
        }
        .indebt-invoices{
            padding-bottom: 15px;
        }
        .indebt-invoices .indebt-invoices-item{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-around;
            align-items: center;
            padding-right: 10px;
            font-size: 16px;
            .inv-detail {
                position: relative;
                display: flex;
                flex-direction: column;
            }
            span {
                position: relative;
                padding: 10px;
            }
            i {
                position: relative;
                display: table;
                background-color: #70C169;
                padding: 10px 12px;
                border-radius: 100%;
                color: white;
            }
        }
    }
}
</style>
